<template>
    <div :id=computed_id
        class="modal fade component-modal">
        <div class="modal-dialog modal-dialog-centered" :class="!expand ? size ? size : ' modal-lg' : ''">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="d-flex justify-content-between w-100">
                        <h5 class="m-0">{{title}}</h5>
                        <span>{{rtitle}}</span>
                    </div>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'id',
        'title',
        'rtitle',
        'expand',
        'size',
    ],
    computed: {
        computed_id() {
            if(this.id == undefined) {
                return ('modal-' + this._uid);
            } else {
                return this.id;
            }
        },
    },
    mounted() {
        const vm = this;
        const modal = $('#'+vm.computed_id);

        vm.$on('closeModal', function() {
            modal.modal('hide');
        });

        modal.on('show.bs.modal', function (event) { 
            vm.$emit('openModal');
            //console.log('row:', vm.$store.state.rowSelected);
        });

        
    },
}
</script>